import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash onInput=this.onInput)}}\n",{ moduleName: "client-portal/components/request/information/information-index.hbs" })